import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import { ThemeProvider, CssBaseline } from '@mui/material'
import useThemeMode from './hooks/useThemeMode'

import './index.css'
import { BrowserRouter } from 'react-router-dom'

// Wrapper-Komponente für Theme-Support
const ThemedApp: React.FC = () => {
  const { theme, toggleTheme, isDarkMode } = useThemeMode()
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
    </ThemeProvider>
  )
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')
const root = ReactDOM.createRoot(rootElement)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemedApp />
    </BrowserRouter>
  </React.StrictMode>
)
